import type { FC } from "react";

import { t } from "i18n/i18n";
import {
  SquareIconButton,
  type SquareIconButtonProps,
} from "mds/components/buttons/SquareIconButton";
import { CrossRemoveIcon } from "mds/icons";

export type CloseButtonProps<T extends React.ElementType = "button"> = Omit<
  SquareIconButtonProps<T>,
  "aria-label" | "kind" | "size"
> & {
  "aria-label"?: string;
  kind?: SquareIconButtonProps<T>["kind"];
  size?: SquareIconButtonProps<T>["size"];
};

export const CloseButton: FC<CloseButtonProps<"button">> = ({
  kind = "tertiary",
  size = "s",
  "aria-label": ariaLabel = t("common.close"),
  ...props
}) => (
  <SquareIconButton aria-label={ariaLabel} kind={kind} size={size} {...props}>
    <CrossRemoveIcon />
  </SquareIconButton>
);

CloseButton.displayName = "CloseButton";
